export enum ValidationModeEnum {
    Aggressive = 'aggressive',
    Passive = 'passive',
    Lazy = 'lazy',
    Eager = 'eager'
}